import { render, staticRenderFns } from "./FriendChat.vue?vue&type=template&id=2e08323c&scoped=true&"
import script from "./FriendChat.vue?vue&type=script&lang=js&"
export * from "./FriendChat.vue?vue&type=script&lang=js&"
import style0 from "./FriendChat.vue?vue&type=style&index=0&id=2e08323c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e08323c",
  null
  
)

export default component.exports